/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Reason_No_WinnerInputs */



/**
* | output |
* | --- |
* | "no winner recorded" |
*
* @param {Twda_Reason_No_WinnerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_reason_no_winner = /** @type {((inputs?: Twda_Reason_No_WinnerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Reason_No_WinnerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("aucun vainqueur enregistré")
	if (locale === "es") return /** @type {LocalizedString} */ ("no hay ganador registrado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("nenhum vencedor registrado")
	if (locale === "it") return /** @type {LocalizedString} */ ("nessun vincitore registrato")
	return /** @type {LocalizedString} */ ("no winner recorded")
});